// extracted by mini-css-extract-plugin
export var label = "_5y-1";
export var reminder = "_5y-0";